import { useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { getLastNumber } from '../utils/utils';
import { ComponentActionsProps } from './component-actions.model';
import { ComponentActionsView } from './component-actions.view';

export const ComponentActionsController = ({
  ruleLabel = 'action',
  ...props
}: ComponentActionsProps) => {
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const onSelectTabFunction = (selectedTab: string) => {
    setSelectedTab(getLastNumber(selectedTab));
  };

  const methods = useFormContext();

  const { control, watch } = methods;

  const { append, fields } = useFieldArray({
    control,
    name: props.formPath,
  });

  const onAddEntryAction = () => {
    const regex = /\d+/;
    const highestNumber = watch(props.formPath).reduce(
      (max: number, criterion: { label: string }) => {
        const numberMatch = regex.exec(criterion.label);
        const number = numberMatch ? parseInt(numberMatch[0]) : 0;
        return Math.max(max, number);
      },
      0
    );

    const nextNumber = highestNumber + 1;

    append({
      action: { name: [] },
      conditionType: 'all',
      groups: [],
      isDefault: true,
      label: `${ruleLabel} ${nextNumber} `,
    });
  };

  const onRemoveEntryAction = (index: number) => {
    const newFields = fields.filter((_, nIndex) => index !== nIndex);

    // Update the labels for all remaining fields after the removed index
    newFields.map((field, currentIndex) => {
      const labelPath = `${ruleLabel} ${currentIndex + 1}`;

      // Type assertion to add the label property
      (field as Record<'id' | 'label', string>).label = labelPath;

      return field;
    });

    methods.setValue(props.formPath, newFields);
  };

  return (
    <ComponentActionsView
      {...{
        ...props,
        selectedTab,
        onSelectTabFunction,
        onAddEntryAction,
        onRemoveEntryAction,
      }}
    />
  );
};
